module.exports = __webpack_public_path__ + "img/img1.c9ebe352.jpg";